export default __webpack_public_path__ + "images/b000d3993de4fa856a31122b4a9ba959-cycling_small.webp";